export default (className, props) =>
    [className, props.isOpen ? 'open' : 'closed'].join(' ').trim();